import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/scriblish_logo.png';
import './Navbar.css';
 
const C = {
    primary:          '#6a37d4',
    primaryLight:     '#ae8dff',
    primaryContainer: '#ede8ff',
    surface:          '#f3f6ff',
    surfaceLow:       '#eaf1ff',
    surfaceHigh:      '#d6e3f9',
    onSurface:        '#252f3c',
    onSurfaceVariant: '#525c6a',
    outlineVariant:   '#a4aebe',
};
 
const LandingNavbar: React.FC = () => {
    const navigate = useNavigate();
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const userMenuRef = useRef<HTMLDivElement>(null);
 
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
 
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
                setShowUserMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
 
    return (
        <nav style={{
            position: 'sticky',
            top: 0,
            zIndex: 50,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: isMobile ? '0 16px' : '0 40px',
            height: isMobile ? '58px' : '64px',
            background: C.surface,
            borderBottom: `1px solid ${C.surfaceHigh}`,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}>
            {/* Logo */}
            <img
                src={logo}
                alt="Scriblish"
                style={{ height: isMobile ? '30px' : '36px', cursor: 'default' }}
            />
 
            {/* Right side */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} ref={userMenuRef}>
                {/* Log In — text link, desktop only */}
                {!isMobile && (
                    <button
                        onClick={() => navigate('/login')}
                        style={{
                            background: 'none', border: 'none',
                            color: C.onSurfaceVariant,
                            fontSize: '0.9rem', fontWeight: '700',
                            cursor: 'pointer', padding: '6px 14px',
                            fontFamily: "'Epilogue', sans-serif",
                            transition: 'color 0.15s',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.color = C.primary; }}
                        onMouseLeave={e => { e.currentTarget.style.color = C.onSurfaceVariant; }}
                    >
                        Log In
                    </button>
                )}
 
                {/* Sign Up — gradient pill */}
                <button
                    onClick={() => navigate('/signup')}
                    style={{
                        background: `linear-gradient(135deg, ${C.primary} 0%, ${C.primaryLight} 100%)`,
                        color: '#fff', border: 'none',
                        borderRadius: '9999px',
                        padding: isMobile ? '8px 18px' : '9px 22px',
                        fontSize: '0.875rem', fontWeight: '700',
                        cursor: 'pointer',
                        fontFamily: "'Epilogue', sans-serif",
                        boxShadow: `0 4px 14px ${C.primary}40`,
                        transition: 'opacity 0.15s, transform 0.15s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.opacity = '0.9'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.opacity = '1';   e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                    Sign Up Free
                </button>
            </div>
 
            <style>{`
                @keyframes navDropIn {
                    from { opacity: 0; transform: translateY(-8px) scale(0.97); }
                    to   { opacity: 1; transform: translateY(0)     scale(1);    }
                }
            `}</style>
        </nav>
    );
};
 
export default LandingNavbar;